import React from "react";
import "../css/returns.scss";
import PolicyPage from "./PolicyPage";

function Returns() {
  return (
    <PolicyPage title="Returns & Refunds">
      <p><em>Last updated: October 16, 2026</em></p>
      <h2>Return Window</h2>
      <p>You may request a return within 14 days after confirmed delivery. Email <a href="mailto:core@danecay.shop">core@danecay.shop</a> before shipping anything back and include the order number, item, reason and relevant photos.</p>

      <h2>Condition Requirements</h2>
      <p>Returned shoes must be unworn outdoors, unaltered and in their original packaging with included accessories. Please try shoes on a clean, soft surface. Items with sole wear, stains, odour or damage caused after delivery may not qualify.</p>

      <h2>Return Authorisation and Timing</h2>
      <p>Wait for our return instructions before sending the parcel. Once authorised, dispatch the return within the time stated in those instructions, use trackable service and keep proof of postage. An unapproved or unidentified parcel may be delayed, refused or returned to sender.</p>

      <h2>Incorrect or Damaged Items</h2>
      <p>Contact us within 48 hours of delivery with photos of the shoes, packaging and shipping label. Once verified, we will provide an appropriate replacement, return instruction or refund at no additional return cost.</p>

      <h2>Change-of-Mind Returns</h2>
      <p>For size preference or change-of-mind returns, the customer is responsible for return postage. Original shipping charges are not refundable unless required by law or the item was incorrect or defective.</p>

      <h2>Exchanges</h2>
      <p>Size or colour exchanges depend on availability. We may process an exchange as a return and new order. Any price difference or additional shipping amount will be disclosed before the replacement is confirmed.</p>

      <h2>Refund Timing</h2>
      <p>Approved refunds are sent to the original payment method after inspection. Processing normally takes 3–7 business days; your payment provider may require additional time to display the credit.</p>

      <h2>Partial or Refused Refunds</h2>
      <p>If a return is incomplete, used beyond a reasonable try-on, altered or damaged after delivery, we may reduce or refuse the refund to the extent permitted by law. We will explain the reason and provide supporting information. This does not affect remedies for a defect that existed at delivery.</p>

      <h2>Return Address</h2>
      <p>Do not send returns to the general business address shown in the footer. We will provide the correct return address with the return authorisation so the parcel can be identified and processed.</p>

      <h2>Mandatory Consumer Rights</h2>
      <p>Some locations provide a longer cooling-off period or additional cancellation, conformity or refund rights. Where a mandatory local rule gives you greater protection than this policy, that rule applies.</p>
    </PolicyPage>
  );
}

export default Returns;
